(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["parralax-reveal"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('.parallax-reveal-section');
  if (!section) return;
  
  const cards = section.querySelectorAll('.parallax-card');
  const progressDots = section.querySelectorAll('.parallax-progress-dot');
  const totalCards = cards.length;
  
  if (totalCards === 0) return;

  function updateParallax() {
    const rect = section.getBoundingClientRect();
    const sectionHeight = section.offsetHeight;
    const viewportHeight = window.innerHeight;
    
    // Calculate scroll progress (0 to 1)
    const scrolled = -rect.top;
    const scrollableDistance = sectionHeight - viewportHeight;
    const progress = Math.max(0, Math.min(1, scrolled / scrollableDistance));
    
    cards.forEach((card, index) => {
      const cardOffset = parseFloat(card.dataset.offset) || 0;
      
      // Calculate individual card progress
      const cardStart = index / totalCards;
      const cardEnd = (index + 1) / totalCards;
      const cardProgress = (progress - cardStart) / (cardEnd - cardStart);
      
      // Calculate transforms
      let translateY, scale, opacity, rotate, zIndex;
      
      if (cardProgress < 0) {
        // Card hasn't appeared yet
        translateY = 100 + (cardOffset * 20);
        scale = 0.8;
        opacity = 0;
        rotate = 5;
        zIndex = index;
      } else if (cardProgress > 1) {
        // Card has passed
        translateY = -100 - (cardOffset * 20);
        scale = 0.9;
        opacity = 0.3;
        rotate = -3;
        zIndex = index;
      } else {
        // Card is active
        const easeProgress = 1 - Math.pow(1 - cardProgress, 3);
        translateY = (1 - easeProgress) * 100 - easeProgress * 50 + (cardOffset * 10);
        scale = 0.8 + (easeProgress * 0.2);
        opacity = Math.min(1, cardProgress * 2) * (cardProgress > 0.7 ? (1 - cardProgress) * 3 + 0.3 : 1);
        rotate = (1 - easeProgress) * 5 - easeProgress * 3;
        zIndex = totalCards + index;
      }
      
      // Calculate horizontal offset based on index
      const xOffset = (index % 2 === 0 ? -1 : 1) * (20 + index * 5);
      
      card.style.transform = `translateY(${translateY}%) translateX(${xOffset}px) scale(${scale}) rotate(${rotate}deg)`;
      card.style.opacity = Math.max(0, Math.min(1, opacity));
      card.style.zIndex = zIndex;
    });
    
    // Update progress dots
    progressDots.forEach((dot, index) => {
      const dotProgress = (progress * totalCards) - index;
      const fill = dot.querySelector('.parallax-progress-fill');
      
      if (dotProgress >= 1) {
        fill.style.height = '100%';
        dot.classList.add('active');
      } else if (dotProgress > 0) {
        fill.style.height = (dotProgress * 100) + '%';
        dot.classList.add('active');
      } else {
        fill.style.height = '0%';
        dot.classList.remove('active');
      }
    });
  }
  
  // Throttled scroll handler
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Initial call
  updateParallax();
})();

  } catch(e) { console.error(e); }
})();
})();
